import React from "react";

const Rattata = ({ ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="-1.25 -0.8 114.4 148.0"
      {...rest}
    >
      <g>
        <path
          fill="#fffbda"
          d="M74.1 121.9 L76.0 123.2 Q79.65 125.55 80.3 126.75 L80.7 128.1 80.65 128.5 79.5 129.55 79.05 129.75 79.3 130.2 79.4 130.65 78.95 133.2 Q75.25 131.45 71.75 131.5 L66.35 131.4 Q63.8 131.15 63.45 130.6 61.5 127.45 65.35 124.3 69.25 121.1 74.1 121.9"
        />
        <path
          fill="#dcd9bd"
          d="M74.1 121.9 L75.3 122.7 Q73.5 123.55 72.8 124.25 71.3 126.4 71.75 128.4 72.1 130.05 73.8 131.8 L71.2 131.75 67.1 131.25 64.95 130.7 Q63.6 130.25 63.45 129.95 62.45 128.25 63.1 126.95 63.8 125.7 66.2 124.45 L70.55 123.6 74.1 121.9"
        />
        <path
          fill="#914897"
          d="M63.5 115.4 Q67.1 115.55 69.2 117.35 70.15 118.15 73.2 120.1 74.55 120.9 73.9 122.05 L71.95 124.0 Q70.4 125.15 67.1 125.2 64.8 125.3 63.85 126.75 62.75 128.35 64.05 130.65 L61.95 129.95 Q58.3 128.4 56.65 127.3 53.95 125.5 53.6 123.5 53.15 121.0 56.0 118.2 59.1 115.15 63.5 115.4"
        />
        <path
          fill="#7f3c83"
          d="M63.5 115.4 Q67.1 115.55 69.2 117.35 70.15 118.15 73.2 120.1 74.6 120.9 73.95 122.6 73.35 124.0 71.95 125.05 70.35 126.25 66.7 126.35 64.9 126.4 64.4 127.8 63.85 129.2 64.95 131.2 L61.95 129.95 Q58.3 128.4 56.65 127.3 53.95 125.5 53.6 123.5 53.15 121.0 56.0 118.2 59.1 115.15 63.5 115.4"
        />
        <path
          fill="#7f3c83"
          d="M34.5 134.45 Q31.05 134.85 29.5 134.5 27.95 134.1 27.2 133.2 26.35 132.15 27.1 132.55 L31.35 130.75 Q35.6 128.95 36.8 129.75 L38.45 131.25 40.05 132.8 40.8 133.55 34.5 134.45"
        />
        <path
          fill="#fffbda"
          d="M58.6 139.15 Q59.95 138.45 60.75 136.5 61.35 135.1 62.3 134.5 63.35 133.9 65.15 134.1 L67.2 134.15 71.0 135.8 74.4 137.4 Q77.8 139.25 77.65 141.25 L76.3 140.9 74.8 140.75 Q76.5 142.35 76.15 144.6 74.85 144.0 72.35 143.5 72.75 144.8 72.5 145.5 64.7 143.0 61.15 142.75 59.15 142.6 57.9 141.85 56.7 141.1 55.85 139.5 L58.6 139.15"
        />
        <path
          fill="#dcd9bd"
          d="M70.2 137.5 Q72.05 137.9 74.35 139.05 76.75 140.25 77.35 141.1 L74.9 140.85 Q72.85 138.6 70.2 137.5"
        />
        <path
          fill="#dcd9bd"
          d="M65.85 139.05 Q71.3 139.4 74.7 143.85 L72.3 143.35 Q71.2 141.9 69.45 140.7 67.55 139.35 65.85 139.05"
        />
        <path
          fill="#0d131a"
          d="M71.8 127.15 L76.0 127.95 Q78.05 128.2 79.3 132.45 79.65 133.6 79.0 133.65 L77.0 133.0 Q74.75 131.8 69.95 131.9 L64.9 131.75 Q63.55 131.45 62.8 129.65 L62.9 129.2 Q63.1 128.95 63.15 129.15 63.75 130.6 66.2 130.95 L70.2 131.05 74.05 131.2 Q76.55 131.5 78.3 132.5 77.9 130.5 77.25 129.6 76.4 128.5 74.95 128.45 73.4 128.4 71.45 127.5 70.55 127.1 70.75 127.0 L71.8 127.15"
        />
        <path
          fill="#0d131a"
          d="M73.35 125.8 Q72.85 125.6 73.0 125.4 73.2 125.2 73.9 125.4 L78.2 126.1 Q79.85 126.15 81.0 127.15 82.0 128.05 83.0 130.1 83.9 131.85 83.8 132.15 L82.15 132.0 79.75 131.2 79.3 130.7 Q79.0 130.25 79.2 130.3 81.75 130.75 82.6 131.25 L81.2 128.35 Q80.1 126.75 78.3 126.7 75.15 126.55 73.35 125.8"
        />
        <path
          fill="#0d131a"
          d="M66.95 118.65 L67.6 118.0 69.55 120.75 Q71.0 122.75 71.75 123.1 74.15 124.2 78.35 124.35 80.3 124.4 83.3 126.95 86.25 129.1 83.5 128.85 L82.05 128.95 81.7 128.5 Q81.5 128.05 81.7 128.05 L83.75 128.2 81.25 126.15 Q79.5 125.05 78.3 125.0 L73.9 124.55 Q71.6 124.05 70.85 123.3 68.4 121.1 66.95 118.65"
        />
        <path
          fill="#fffbda"
          d="M77.9 133.45 L80.45 132.9 Q81.3 132.35 81.7 130.8 81.9 129.9 82.9 129.05 83.9 128.1 84.95 128.05 L86.2 128.1 87.4 128.0 90.2 129.1 92.35 129.9 Q95.45 130.75 96.25 133.55 L94.15 133.45 Q95.45 135.5 95.3 137.3 93.5 136.45 91.6 136.3 92.6 138.7 91.8 138.3 L88.95 137.2 85.6 136.25 81.35 135.6 Q78.1 134.85 77.9 133.45"
        />
        <path
          fill="#dcd9bd"
          d="M90.4 131.05 Q93.9 131.65 95.8 133.55 L93.95 133.35 Q92.0 131.6 90.4 131.05"
        />
        <path
          fill="#dcd9bd"
          d="M79.65 135.05 Q78.5 134.5 78.05 133.75 79.55 133.9 80.65 133.3 81.85 132.6 82.05 131.3 84.45 133.3 87.4 134.45 88.45 134.85 89.65 136.0 90.85 137.15 91.1 138.1 89.65 137.25 86.55 136.5 L82.1 135.7 Q80.75 135.65 79.65 135.05"
        />
        <path
          fill="#dcd9bd"
          d="M85.2 132.05 Q87.55 131.9 90.6 133.4 93.65 134.95 95.0 137.05 93.2 136.2 91.55 136.25 89.75 133.6 85.2 132.05"
        />
        <path
          fill="#914897"
          d="M62.5 89.0 Q63.45 86.9 65.6 84.85 68.1 82.55 70.5 82.1 74.15 81.5 75.7 83.05 76.45 83.8 76.65 90.15 L76.8 95.8 Q76.95 99.3 77.6 101.95 78.8 106.85 83.9 124.05 84.5 126.1 86.4 127.25 87.45 127.9 87.2 128.25 L86.25 128.4 Q84.75 128.2 83.6 128.95 82.3 129.75 82.1 131.25 81.9 132.6 80.65 133.25 79.5 133.9 77.9 133.75 L77.1 131.6 75.85 129.5 Q70.4 122.9 67.05 118.15 65.75 116.3 64.95 114.3 64.2 112.5 64.2 111.45 64.25 109.9 62.8 99.65 61.6 91.0 62.5 89.0"
        />
        <path
          fill="#7f3c83"
          d="M64.35 97.7 Q65.55 93.4 69.35 89.0 73.0 84.8 75.95 83.95 76.45 85.95 76.6 90.8 L76.75 96.9 Q73.15 98.2 71.0 101.85 68.6 105.95 69.85 110.5 70.95 114.45 74.4 120.65 77.5 126.25 80.1 129.4 L82.05 131.3 Q81.85 132.6 80.65 133.3 79.55 133.9 78.05 133.75 L77.8 133.2 Q77.6 132.35 73.05 126.35 68.6 120.45 66.8 118.6 65.0 116.8 64.1 109.5 63.15 102.05 64.35 97.7"
        />
        <path
          fill="#914897"
          d="M35.25 128.95 Q37.95 130.45 38.45 131.15 39.5 132.5 41.2 133.65 L40.25 133.85 Q39.75 134.15 39.7 134.6 39.55 136.2 38.3 136.9 37.05 137.6 34.1 137.85 31.45 138.0 30.75 138.4 29.85 138.95 28.95 141.15 25.6 140.3 21.95 136.9 20.45 135.55 20.5 133.3 20.55 131.05 22.2 129.25 23.55 127.9 25.8 127.5 L30.15 127.25 Q32.1 127.25 35.25 128.95"
        />
        <path
          fill="#0d131a"
          d="M75.8 86.1 Q75.6 84.2 75.05 83.65 73.1 81.7 70.5 82.15 68.1 82.6 65.6 84.9 63.45 86.95 62.5 89.05 60.9 92.5 64.2 111.5 64.9 115.55 71.45 123.1 L75.75 128.85 75.75 128.9 Q77.7 131.5 78.0 132.4 78.5 133.95 79.45 134.5 80.4 135.05 83.0 135.45 L87.65 136.3 Q89.2 136.75 91.45 137.75 90.9 135.6 89.2 134.25 87.75 133.05 85.0 132.3 84.25 132.05 84.5 131.95 L85.55 132.0 Q90.75 133.4 91.95 136.8 92.45 138.2 92.0 138.4 91.6 138.6 89.75 137.8 87.2 136.65 82.9 136.2 80.3 135.95 79.0 135.15 77.65 134.35 77.1 132.65 76.9 131.9 74.55 128.75 L69.9 122.9 64.85 117.4 Q62.55 114.65 62.15 112.65 61.5 107.65 61.1 102.25 60.3 91.4 61.6 88.65 62.65 86.4 64.95 84.25 67.65 81.7 70.35 81.2 73.75 80.6 75.7 82.55 L76.1 82.95 Q76.8 83.65 77.0 85.9 L77.15 90.75 Q77.4 98.4 78.6 103.3 81.6 115.45 84.65 124.65 85.15 126.25 86.9 127.3 88.35 128.2 91.35 129.1 94.85 130.15 95.9 132.15 L96.55 133.7 95.4 133.85 94.1 133.8 Q93.85 133.85 93.7 133.5 93.55 133.2 93.75 133.15 L95.7 133.3 Q95.0 131.0 91.15 129.8 87.1 128.6 84.9 126.85 84.15 126.35 83.75 125.05 L80.45 114.05 77.25 102.2 Q76.25 98.15 76.0 90.35 L75.8 86.1"
        />
        <path
          fill="#0d131a"
          d="M92.6 131.95 Q94.8 133.35 95.45 135.5 95.9 137.0 95.65 137.3 L94.25 137.15 91.7 136.65 Q91.5 136.65 91.3 136.3 91.1 135.9 91.3 135.9 93.2 135.85 95.05 136.75 95.0 134.35 92.5 132.6 90.9 131.45 87.8 130.4 87.05 130.15 87.35 130.05 L88.35 130.15 Q91.05 131.0 92.6 131.95"
        />
        <path
          fill="#0d131a"
          d="M42.65 9.4 Q44.4 15.1 41.85 21.1 39.75 26.1 36.2 29.35 32.75 32.45 28.8 33.2 L24.9 33.55 Q23.05 33.4 21.75 32.35 13.2 45.2 13.2 62.35 13.2 74.8 17.15 88.35 19.15 95.15 21.25 99.6 23.6 104.3 23.6 107.15 23.6 108.4 22.95 108.75 21.55 109.7 17.85 104.7 7.75 90.9 3.3 76.45 -1.25 61.5 0.45 46.5 1.85 34.4 6.45 23.1 10.5 13.1 15.65 7.0 20.35 1.5 26.85 0.3 32.65 -0.8 36.95 1.85 41.05 4.35 42.65 9.4"
        />
        <path
          fill="#914897"
          d="M41.35 9.9 Q42.9 14.85 40.5 20.5 38.45 25.4 35.3 28.5 32.2 31.55 28.6 32.25 26.55 32.65 24.7 32.2 22.85 31.75 21.65 30.6 L21.25 30.15 20.9 30.65 Q8.35 49.0 13.05 76.2 15.4 89.85 20.4 100.05 21.85 103.0 22.4 105.55 22.85 107.7 22.45 107.95 L21.7 107.55 Q20.55 106.65 18.65 104.1 8.8 90.7 4.55 75.95 0.35 61.15 2.05 46.1 3.35 34.3 8.1 23.4 12.1 14.25 17.35 8.0 21.95 2.55 27.6 1.6 32.3 0.8 36.15 3.2 39.95 5.55 41.35 9.9"
        />
        <path
          fill="#7f3c83"
          d="M40.6 8.1 Q43.45 13.7 40.5 20.5 38.45 25.4 35.3 28.5 32.2 31.55 28.6 32.25 26.55 32.65 24.7 32.2 22.85 31.75 21.65 30.6 L21.25 30.15 20.9 30.65 Q8.35 49.0 13.05 76.2 15.4 89.85 20.4 100.05 L21.35 102.15 Q10.05 88.6 8.7 65.15 7.25 41.0 17.9 24.45 18.0 24.2 18.7 24.85 19.7 25.8 20.85 26.15 25.1 27.5 32.75 22.15 36.15 22.15 38.95 16.9 41.7 11.75 40.6 8.1"
        />
        <path
          fill="#0d131a"
          d="M23.0 9.2 Q25.8 7.3 28.7 7.25 31.65 7.2 33.2 9.0 34.95 11.05 35.2 13.95 35.4 16.6 34.2 19.45 33.7 20.75 33.3 20.55 32.85 20.35 33.45 18.9 34.15 17.05 34.0 14.65 33.8 11.75 32.35 10.0 31.25 8.7 28.75 8.9 26.2 9.05 23.8 10.75 17.55 15.1 18.45 23.95 18.8 27.65 21.45 30.45 L21.25 31.85 Q19.6 30.85 18.5 29.0 17.25 26.95 17.0 24.35 15.95 14.0 23.0 9.2"
        />
        <path
          fill="#fffbda"
          d="M43.65 135.0 Q46.8 136.25 47.95 137.25 49.1 138.3 49.5 140.5 L46.15 139.75 Q46.85 140.9 47.1 142.25 L47.4 144.85 Q43.25 142.85 41.95 142.8 L42.2 145.2 Q42.3 146.55 42.0 146.65 41.75 146.75 40.65 146.0 L38.55 144.65 Q35.95 143.2 28.7 141.35 29.25 139.15 30.1 138.35 31.05 137.4 33.2 137.5 36.3 137.7 37.95 136.85 39.45 136.1 39.6 134.6 39.75 133.45 40.85 133.5 40.9 133.9 43.65 135.0"
        />
        <path
          fill="#7f3c83"
          d="M23.85 135.7 Q25.15 137.2 29.45 139.2 L28.8 141.15 Q24.8 139.65 23.4 138.5 20.45 136.2 20.3 133.85 20.15 131.7 22.2 129.25 L23.85 130.35 23.05 132.1 Q22.5 134.15 23.85 135.7"
        />
        <path
          fill="#dcd9bd"
          d="M38.35 144.5 Q36.0 143.25 33.85 142.7 L28.8 141.15 29.45 139.2 33.55 140.8 Q40.25 142.85 41.95 146.5 L38.35 144.5"
        />
        <path
          fill="#0d131a"
          d="M39.65 77.3 Q38.45 79.15 37.1 79.85 28.4 84.4 25.05 88.05 22.1 91.3 18.8 101.1 15.1 112.0 16.3 117.4 17.45 122.65 19.9 125.9 22.3 129.1 26.25 130.6 L29.4 131.05 31.8 130.4 Q34.0 129.6 35.4 129.8 L35.7 129.85 Q48.6 131.85 52.85 128.8 53.85 128.05 56.1 126.75 60.95 123.9 63.2 121.75 67.05 118.05 68.65 112.8 69.7 109.2 70.05 105.15 L70.25 98.35 Q70.25 94.6 70.4 93.2 70.6 90.6 71.45 89.05 72.35 87.25 74.7 84.95 57.45 83.2 41.4 72.35 L41.15 73.85 Q40.7 75.6 39.65 77.3 M23.55 87.6 Q26.65 84.2 36.4 78.9 38.1 78.0 39.15 75.9 40.25 73.7 40.15 70.95 57.3 83.1 75.1 84.7 72.85 86.8 71.95 90.3 71.1 93.6 71.1 99.3 71.15 110.75 68.65 116.1 65.8 122.25 56.95 127.5 L53.75 129.6 Q49.25 132.85 35.55 130.8 L35.25 130.75 Q34.05 130.6 32.1 131.3 L29.5 132.0 Q27.8 132.2 25.95 131.5 21.55 129.8 18.85 126.8 15.95 123.5 14.75 118.2 13.5 112.45 17.15 101.2 20.5 90.95 23.55 87.6"
        />
        <path
          fill="#914897"
          d="M25.05 88.05 Q28.4 84.4 37.1 79.85 38.45 79.15 39.65 77.3 40.7 75.6 41.15 73.85 L41.4 72.35 Q57.45 83.2 74.7 84.95 72.35 87.25 71.45 89.05 70.6 90.6 70.4 93.2 70.25 94.6 70.25 98.35 L70.05 105.15 Q69.7 109.2 68.65 112.8 67.05 118.05 63.2 121.75 60.95 123.9 56.1 126.75 53.85 128.05 52.85 128.8 48.6 131.85 35.7 129.85 L35.4 129.8 Q34.0 129.6 31.8 130.4 L29.4 131.05 26.25 130.6 Q22.3 129.1 19.9 125.9 17.45 122.65 16.3 117.4 15.1 112.0 18.8 101.1 22.1 91.3 25.05 88.05"
        />
        <path
          fill="#7f3c83"
          d="M36.8 84.2 Q26.15 88.4 21.0 95.4 23.35 90.0 25.05 88.05 28.4 84.4 37.1 79.85 38.45 79.15 39.65 77.3 40.7 75.6 41.15 73.85 L41.4 72.35 45.0 75.05 48.7 77.5 Q47.4 79.65 44.0 81.3 L36.8 84.2"
        />
        <path
          fill="#fffbda"
          d="M55.8 80.9 L62.5 82.65 74.25 84.4 Q72.2 86.3 71.3 89.35 70.35 92.5 70.25 98.35 L70.0 105.15 Q69.7 109.3 68.65 112.8 67.05 118.05 63.2 121.75 60.95 123.9 56.1 126.75 53.85 128.05 52.85 128.8 48.6 131.85 35.75 129.85 L35.75 125.35 Q36.0 120.0 39.15 114.3 41.05 110.9 46.1 104.25 51.25 97.5 54.5 90.35 L55.75 85.55 Q56.4 82.05 55.8 80.9"
        />
        <path
          fill="#dcd9bd"
          d="M55.75 118.6 Q65.35 116.35 69.6 108.75 L68.65 112.8 Q67.05 118.05 63.2 121.75 60.95 123.9 56.1 126.75 53.85 128.05 52.85 128.8 48.6 131.85 35.75 129.85 L35.75 125.35 Q35.95 121.55 37.6 117.45 46.8 120.7 55.75 118.6"
        />
        <path
          fill="#914897"
          d="M55.45 96.6 L57.95 114.9 Q59.05 122.2 62.0 127.9 64.75 133.25 67.4 134.05 67.8 134.4 67.15 134.65 L66.0 134.75 Q64.35 134.25 63.15 134.75 61.85 135.35 61.35 137.0 60.4 140.15 56.05 140.2 L54.05 137.45 49.65 131.2 43.3 122.75 Q40.1 118.3 39.85 116.75 36.3 97.2 37.5 92.75 L53.05 86.05 Q54.2 87.35 55.45 96.6"
        />
        <path
          fill="#fffbda"
          d="M83.45 79.5 Q77.55 82.4 75.55 83.85 72.35 86.15 71.4 90.8 L55.9 86.75 Q56.85 85.3 56.9 83.5 57.0 81.55 55.85 80.85 52.5 79.5 49.15 77.8 42.5 74.35 40.3 71.1 L38.9 62.55 45.8 55.3 88.35 47.75 94.65 50.3 96.85 55.55 Q98.8 61.45 97.5 64.8 95.95 68.85 92.3 72.65 88.6 76.6 83.45 79.5"
        />
        <path
          fill="#914897"
          d="M92.6 43.8 Q94.65 51.35 95.05 52.15 94.0 51.05 93.05 51.35 L85.9 52.8 Q86.05 53.5 86.95 55.6 88.0 57.75 84.9 61.65 81.85 65.5 79.15 65.55 76.2 65.65 72.0 63.5 67.5 61.15 67.3 58.85 67.25 58.2 66.8 57.25 L48.95 58.5 Q43.3 59.6 41.55 63.4 39.75 67.4 42.75 73.2 L39.85 70.0 Q36.95 66.15 37.1 62.6 37.3 59.15 38.6 56.35 L40.4 52.8 42.15 47.5 Q43.65 43.55 45.1 42.5 L48.75 33.05 53.45 29.35 Q59.8 25.6 68.1 25.6 72.75 25.6 78.1 27.55 84.5 29.9 87.85 33.85 90.9 37.45 92.6 43.8"
        />
        <path
          fill="#914897"
          d="M84.8 61.5 Q87.75 57.65 86.15 54.55 L86.85 54.5 Q88.4 57.65 85.25 61.85 82.2 65.85 79.15 65.95 75.75 66.0 71.7 64.1 66.65 61.7 66.5 58.1 67.0 58.7 67.3 58.25 67.35 60.8 71.75 63.2 75.95 65.5 79.2 65.3 82.0 65.1 84.8 61.5"
        />
        <path
          fill="#fdeabe"
          d="M93.1 18.05 Q98.2 24.85 98.2 32.25 98.15 40.15 91.6 40.5 L89.95 37.1 Q87.65 33.2 84.3 30.95 86.25 23.35 87.05 21.35 89.1 16.45 91.85 17.25 L93.1 18.05"
        />
        <path
          fill="#fdeabe"
          d="M41.85 47.6 Q36.55 49.75 32.3 49.1 28.35 48.5 27.85 46.05 26.75 40.45 28.1 35.5 29.1 31.7 32.6 25.25 L33.8 25.8 36.85 28.05 Q41.8 32.75 45.15 42.1 L41.85 47.6"
        />
        <path
          fill="#ba0031"
          d="M91.7 53.0 Q90.4 53.75 88.1 53.95 L86.1 53.95 Q84.55 47.85 86.3 41.8 90.9 45.65 91.7 53.0"
        />
        <path
          fill="#ffffff"
          d="M87.5 38.5 Q90.05 40.2 91.9 45.5 93.5 50.1 93.1 51.35 92.8 52.4 91.7 53.0 90.9 45.65 86.3 41.8 L87.1 39.4 87.5 38.5"
        />
        <path
          fill="#ffffff"
          d="M51.25 44.45 Q53.2 45.0 55.4 46.05 53.2 49.0 53.05 53.15 52.95 56.9 54.5 60.7 50.35 60.85 49.35 59.85 48.15 58.75 48.55 53.05 48.95 46.85 51.25 44.45"
        />
        <path
          fill="#ba0031"
          d="M66.9 57.35 Q66.85 58.3 62.6 59.4 58.5 60.5 54.5 60.7 52.95 56.9 53.05 53.15 53.2 49.0 55.4 46.05 59.6 48.2 63.05 51.8 66.25 55.05 66.9 57.35"
        />
        <path
          fill="#ffffff"
          d="M68.65 67.3 Q72.5 69.2 76.55 69.25 80.7 69.3 84.2 67.4 83.3 71.75 80.2 78.35 79.25 79.6 76.35 80.2 74.8 80.5 73.45 80.2 L72.4 79.8 Q71.75 79.2 68.65 67.3"
        />
        <path
          fill="#dbdcdc"
          d="M72.05 68.7 Q71.95 73.9 73.2 76.5 74.95 80.1 79.35 79.05 L76.7 80.1 Q73.75 80.85 72.4 79.65 69.35 71.9 68.75 67.4 L72.05 68.7"
        />
        <path
          fill="#dacaa5"
          d="M86.55 32.85 L84.45 31.05 Q85.5 24.05 87.1 20.8 87.95 19.0 89.65 17.6 91.1 16.45 92.95 17.35 L95.85 22.7 Q92.5 20.45 90.25 22.85 87.95 25.3 86.55 32.85"
        />
        <path
          fill="#dacaa5"
          d="M43.4 44.45 Q41.4 38.3 37.0 33.7 32.4 28.95 29.65 30.7 L32.25 25.2 33.65 25.75 Q35.4 26.6 37.05 28.1 42.45 32.9 45.15 42.4 L43.4 44.45"
        />
        <path
          fill="#7f3c83"
          d="M50.1 36.55 L48.65 33.15 Q51.85 29.8 56.8 27.8 L61.15 26.5 Q56.35 28.1 53.1 31.6 50.5 34.35 50.1 36.55"
        />
        <path
          fill="#7f3c83"
          d="M87.0 58.6 Q86.1 61.35 83.65 63.65 81.2 65.9 79.15 65.95 76.25 66.0 72.45 64.4 67.8 62.45 66.75 59.5 L66.85 59.15 Q65.95 54.15 60.05 49.4 54.65 45.05 50.0 44.45 48.2 44.25 48.15 43.7 48.05 43.05 51.85 42.9 56.7 42.7 60.6 44.7 64.25 46.55 66.6 50.2 68.45 53.0 69.25 55.5 69.9 57.65 71.2 59.25 73.95 62.65 78.8 62.4 83.6 62.15 87.0 58.6"
        />
        <path
          fill="#dcd9bd"
          d="M42.85 73.55 L42.75 73.2 Q40.6 69.05 40.95 65.8 41.25 62.65 43.75 60.7 L45.6 61.25 45.2 63.6 Q45.05 66.15 46.35 67.25 46.95 67.8 48.1 72.9 50.1 78.2 55.25 80.35 53.2 79.95 49.9 78.25 46.0 76.25 42.85 73.55"
        />
        <path
          fill="#7f3c83"
          d="M39.85 70.0 Q36.95 66.15 37.1 62.6 37.3 58.85 39.15 55.3 39.7 59.05 43.75 60.7 41.25 62.65 40.95 65.8 40.6 69.05 42.75 73.2 L39.85 70.0"
        />
        <path
          fill="#990024"
          d="M85.5 45.25 L86.25 42.05 Q88.85 43.25 90.35 47.3 L91.35 51.1 Q91.1 50.55 90.45 50.55 89.75 50.6 88.9 51.55 87.95 52.7 86.7 52.55 L85.7 52.2 Q84.9 49.1 85.5 45.25"
        />
        <path
          fill="#990024"
          d="M59.7 48.8 Q64.3 52.2 66.25 56.2 L65.5 55.9 Q64.6 55.7 63.75 56.4 62.4 57.55 61.45 57.8 59.9 58.2 57.95 57.15 56.6 56.45 55.3 56.9 53.95 57.3 53.6 58.7 52.05 49.75 55.45 46.2 L59.7 48.8"
        />
        <path
          fill="#914897"
          d="M81.0 19.9 Q82.3 17.3 84.75 14.35 86.75 11.95 89.2 12.5 91.7 13.05 94.3 16.55 97.15 20.3 98.8 25.05 100.5 30.0 100.3 34.25 100.1 38.35 98.3 40.95 96.4 43.65 92.95 44.55 L91.5 40.7 Q94.25 40.6 96.05 38.7 98.05 36.55 98.5 32.45 98.75 30.0 96.6 24.75 94.85 20.55 92.7 17.0 86.8 15.6 84.3 30.9 82.85 29.8 78.6 27.8 79.05 23.6 81.0 19.9"
        />
        <path
          fill="#ffffff"
          d="M85.45 47.9 L85.6 46.6 Q86.95 46.4 87.5 48.7 88.05 51.2 86.6 51.45 86.2 51.5 85.85 51.15 L85.45 50.25 85.45 47.9"
        />
        <path
          fill="#ffffff"
          d="M63.05 52.2 L63.3 53.2 Q63.45 54.5 62.8 55.4 62.15 56.3 61.2 56.25 60.5 56.25 59.95 55.35 59.3 54.35 59.3 53.05 59.3 50.45 60.85 50.2 L63.05 52.2"
        />
        <path
          fill="#0d131a"
          d="M86.6 32.05 Q91.1 36.25 92.55 42.25 94.55 50.15 97.2 55.85 103.75 70.2 77.7 83.0 74.55 84.55 72.8 87.95 71.95 89.65 71.7 91.05 71.7 91.25 71.3 91.25 70.85 91.25 70.9 91.05 71.25 88.5 72.65 86.35 74.35 83.65 77.3 82.2 87.8 77.0 92.9 71.3 99.65 63.7 96.05 55.85 94.6 52.5 93.4 48.5 L91.8 42.7 Q90.2 36.95 85.9 32.9 81.55 28.85 75.15 27.2 67.85 25.4 60.55 27.2 53.2 29.05 48.95 33.75 48.85 33.9 48.5 33.5 48.15 33.05 48.3 32.9 52.25 28.55 59.35 26.5 67.3 24.15 75.35 26.15 82.1 27.85 86.6 32.05"
        />
        <path
          fill="#0d131a"
          d="M87.35 38.9 L87.4 38.4 Q87.55 38.0 87.7 38.1 90.3 40.1 92.15 45.35 93.75 49.85 93.45 51.7 93.0 54.2 86.35 54.25 L86.2 53.7 86.35 53.45 89.75 53.25 Q92.35 52.5 92.5 51.5 92.85 49.85 91.4 45.65 89.75 40.9 87.35 38.9"
        />
        <path
          fill="#0d131a"
          d="M86.1 42.05 Q85.9 41.95 86.15 41.65 86.35 41.3 86.5 41.4 88.85 43.1 90.45 46.55 92.05 50.0 91.9 53.1 L91.5 53.25 91.15 52.95 Q91.4 50.8 89.85 47.2 88.15 43.35 86.1 42.05"
        />
        <path
          fill="#0d131a"
          d="M50.95 44.35 L51.45 44.45 Q51.8 44.65 51.65 44.8 49.25 47.95 49.0 53.6 48.8 58.7 49.95 59.6 51.55 60.85 58.7 59.7 65.8 58.55 66.4 57.15 66.45 56.95 66.7 57.25 L66.85 57.7 Q66.1 59.45 58.65 60.65 L49.25 60.4 Q47.75 59.2 48.0 53.8 48.25 47.9 50.95 44.35"
        />
        <path
          fill="#0d131a"
          d="M55.05 45.75 L55.5 45.85 55.65 46.25 Q53.65 48.85 53.6 53.6 53.5 57.85 54.8 60.6 L54.55 60.9 Q54.15 61.1 54.1 60.9 52.5 57.6 52.6 53.4 52.75 48.75 55.05 45.75"
        />
        <path
          fill="#0d131a"
          d="M84.05 61.6 L83.0 62.7 Q82.75 62.65 83.3 61.7 84.35 59.85 84.55 57.95 84.6 57.6 84.85 57.9 85.15 58.25 85.1 59.1 L84.7 60.5 84.05 61.6"
        />
        <path
          fill="#0d131a"
          d="M77.65 62.7 Q78.55 63.45 78.35 63.7 78.2 63.9 77.3 63.3 76.1 62.5 75.6 61.65 75.0 60.8 75.25 60.75 L76.1 61.3 77.65 62.7"
        />
        <path
          fill="#0d131a"
          d="M86.5 65.2 Q83.85 69.45 77.9 69.7 73.7 69.85 69.5 68.05 68.4 67.55 67.55 68.05 66.65 68.65 65.25 70.85 64.5 72.05 64.25 71.9 63.95 71.7 64.55 70.55 65.8 67.95 66.7 67.3 L69.7 67.25 Q73.7 68.95 77.85 68.75 80.6 68.65 82.3 67.9 84.15 67.05 85.8 64.9 86.65 63.85 86.9 64.0 87.15 64.15 86.5 65.2"
        />
        <path
          fill="#0d131a"
          d="M83.75 67.45 L84.25 67.15 84.65 67.2 82.4 74.15 80.6 78.4 Q79.8 79.7 76.9 80.45 L72.2 80.2 Q71.45 79.6 69.8 73.55 L68.2 67.35 68.65 67.25 Q69.15 67.3 69.2 67.5 L70.45 72.4 72.45 78.9 72.75 79.55 Q72.9 79.7 73.4 79.85 74.85 80.25 76.75 79.85 78.7 79.4 79.75 78.3 81.05 76.25 83.75 67.45"
        />
        <path
          fill="#0d131a"
          d="M77.7 75.1 L76.65 80.2 Q76.6 80.4 76.15 80.4 75.7 80.4 75.75 80.2 L76.95 75.0 Q77.35 73.2 77.65 73.2 78.0 73.2 77.7 75.1"
        />
        <path
          fill="#0d131a"
          d="M86.3 69.0 L86.55 70.35 Q86.3 70.4 85.7 69.2 L84.35 67.15 Q84.2 67.0 84.55 66.7 84.95 66.4 85.05 66.55 85.85 67.45 86.3 69.0"
        />
        <path
          fill="#0d131a"
          d="M49.85 43.8 Q55.95 44.65 61.6 49.55 66.75 54.05 67.2 57.7 67.45 59.3 67.15 59.8 66.85 60.3 66.4 58.25 65.55 54.1 60.2 49.8 54.85 45.45 49.65 44.65 47.55 44.35 47.55 43.9 L49.85 43.8"
        />
        <path
          fill="#0d131a"
          d="M84.8 47.7 Q84.9 42.55 87.3 38.15 88.15 36.7 88.5 36.75 88.9 36.8 88.05 38.4 85.85 42.5 85.7 47.5 85.6 51.6 86.75 54.15 87.3 55.35 87.05 55.5 86.8 55.7 86.15 54.55 84.7 52.15 84.8 47.7"
        />
        <path
          fill="#fffbda"
          d="M112.3 45.95 L102.8 52.55 93.55 60.6 Q92.8 61.3 92.1 59.55 91.35 57.75 92.5 56.5 96.3 52.35 100.0 50.15 102.9 48.5 106.05 47.3 109.9 45.85 112.3 45.95"
        />
        <path
          fill="#0d131a"
          d="M111.25 46.45 Q108.15 46.55 103.05 49.2 97.9 51.9 94.35 55.3 92.8 56.85 92.5 56.55 92.2 56.25 93.75 54.7 97.0 51.45 101.3 49.05 106.05 46.4 110.3 45.8 L112.95 45.75 Q113.15 46.1 110.9 47.6 100.1 54.7 95.25 59.5 93.75 60.95 93.55 60.6 93.35 60.25 94.7 58.8 97.9 55.4 103.6 51.35 L111.25 46.45"
        />
        <path
          fill="#dcd9bd"
          d="M67.55 142.5 Q69.55 143.35 70.35 143.85 L72.2 145.45 67.35 143.95 62.6 142.9 58.6 142.1 Q57.1 141.5 56.2 140.2 59.4 140.15 60.75 138.25 63.75 140.9 67.55 142.5"
        />
        <path
          fill="#7f3c83"
          d="M60.75 138.25 Q59.4 140.15 56.2 140.2 L56.05 140.0 50.5 132.55 43.2 123.0 Q40.9 120.35 39.7 116.05 38.4 111.45 38.1 104.05 37.95 100.9 41.55 106.65 44.9 111.95 46.2 115.55 47.55 119.3 52.0 126.5 56.3 133.45 59.05 136.55 L60.75 138.25"
        />
        <path
          fill="#914897"
          d="M50.25 37.35 Q50.8 39.45 48.5 41.65 46.2 43.8 45.1 42.5 43.85 37.05 40.15 31.8 36.25 26.35 32.6 25.25 31.85 25.45 29.9 30.2 27.7 35.55 26.85 40.55 26.5 44.2 28.0 46.6 29.65 49.25 33.2 49.45 L37.4 48.95 41.95 47.85 40.85 51.55 Q37.9 52.55 33.9 52.8 26.85 53.15 24.2 46.85 21.85 41.1 24.75 30.7 27.9 19.5 34.1 19.25 39.7 19.05 45.55 28.15 48.45 32.75 50.25 37.35"
        />
        <path
          fill="#0d131a"
          d="M49.8 34.9 Q50.8 37.25 50.35 37.35 49.95 37.4 49.05 35.4 46.3 29.4 42.4 25.0 37.8 19.8 33.9 19.95 31.0 20.05 28.75 23.3 26.45 26.55 25.0 32.65 21.85 45.9 26.5 50.2 28.7 52.2 32.55 52.4 36.35 52.6 40.9 51.0 L41.05 51.4 Q41.05 51.85 40.85 51.9 36.05 53.55 32.2 53.35 28.3 53.1 25.9 50.95 23.25 48.5 22.7 43.65 22.2 38.85 23.8 32.25 25.45 25.5 28.3 21.95 30.85 18.8 33.85 18.7 38.25 18.55 43.25 24.2 47.4 28.95 49.8 34.9"
        />
        <path
          fill="#0d131a"
          d="M81.95 17.15 Q85.4 11.75 88.2 11.8 91.45 11.85 94.7 16.1 97.75 20.0 99.55 25.65 101.0 30.1 100.9 34.1 100.75 38.0 99.2 40.65 97.05 44.2 92.7 44.95 92.5 45.0 92.4 44.55 92.35 44.1 92.55 44.05 96.55 43.3 98.4 40.15 101.4 35.15 98.55 26.15 97.05 21.4 94.6 17.8 91.45 13.1 88.15 13.05 85.95 13.0 82.75 18.05 79.45 23.2 79.0 27.9 L78.55 27.85 78.05 27.45 Q78.55 22.45 81.95 17.15"
        />
        <path
          fill="#0d131a"
          d="M41.55 47.55 Q42.05 45.75 43.15 44.15 L44.6 42.4 Q42.65 36.2 39.6 31.9 36.5 27.6 32.95 26.05 30.35 24.95 30.55 24.4 30.75 23.85 33.3 24.9 36.95 26.4 40.15 30.9 43.25 35.25 45.4 41.7 L45.55 42.55 45.1 43.3 Q43.2 45.75 42.45 48.3 41.1 53.0 39.6 55.45 34.95 63.2 41.05 70.65 45.65 76.3 53.8 79.5 56.1 80.45 55.9 80.85 55.7 81.25 53.45 80.4 44.85 77.0 39.85 71.15 33.2 63.25 38.65 55.25 39.7 53.8 41.55 47.55"
        />
        <path
          fill="#dcd9bd"
          d="M41.2 140.1 Q44.05 141.45 45.8 142.85 47.0 143.75 47.4 145.1 45.45 143.4 41.75 142.6 41.35 141.85 39.95 140.95 L37.05 139.15 Q37.9 138.6 41.2 140.1"
        />
        <path
          fill="#dcd9bd"
          d="M41.55 137.0 L45.0 137.75 Q46.4 138.0 47.15 138.45 L49.35 140.45 46.1 139.95 Q45.85 139.6 44.2 138.6 L41.55 137.0"
        />
        <path
          fill="#0d131a"
          d="M36.95 92.6 Q37.1 91.15 37.6 91.3 38.05 91.45 37.95 93.55 37.85 95.0 38.7 103.75 39.55 112.8 40.15 116.1 L40.25 116.65 Q40.5 118.15 47.15 127.15 L55.05 137.95 Q57.55 141.95 60.15 142.2 L66.0 143.1 Q68.65 143.7 71.95 144.9 71.95 142.85 69.8 141.25 67.95 139.85 65.05 139.1 64.25 138.9 64.55 138.8 L65.7 138.9 Q68.6 139.5 70.45 140.9 72.5 142.5 72.75 144.8 72.85 145.7 72.35 145.75 71.85 145.8 69.95 145.05 65.5 143.35 60.75 143.05 58.35 142.85 57.0 141.8 55.75 140.8 53.75 137.65 L46.2 127.75 Q39.7 119.05 39.3 116.85 L39.2 116.3 Q36.1 99.1 36.95 92.6"
        />
        <path
          fill="#0d131a"
          d="M52.6 86.35 Q51.95 85.25 52.0 84.8 52.1 84.3 53.35 85.75 55.55 88.3 57.2 101.85 L58.35 114.85 Q58.8 118.3 61.0 124.0 63.35 130.05 65.35 132.2 L68.05 134.15 71.2 135.5 Q73.75 136.55 74.9 137.2 76.7 138.3 77.35 139.65 L77.9 141.3 76.7 141.25 74.95 141.15 74.65 140.85 Q74.5 140.5 74.7 140.5 L77.05 140.75 Q76.4 138.05 70.95 136.25 67.6 135.1 64.7 132.7 62.65 131.0 60.1 124.2 57.8 118.2 57.4 114.95 L56.15 102.6 Q54.5 89.45 52.6 86.35"
        />
        <path
          fill="#0d131a"
          d="M68.25 137.25 Q67.35 137.05 67.6 136.9 L68.65 136.95 Q71.65 137.6 73.55 139.1 75.8 140.85 76.2 143.6 76.3 144.55 76.05 144.75 L75.0 144.55 72.35 143.8 72.0 143.45 Q71.85 143.1 72.05 143.1 74.15 143.2 75.5 144.1 75.45 141.45 73.15 139.55 71.2 137.95 68.25 137.25"
        />
        <path
          fill="#0d131a"
          d="M41.1 133.45 Q42.15 134.15 43.95 134.75 46.25 135.5 47.5 136.4 48.8 137.4 49.35 138.85 49.95 140.3 49.75 140.65 L48.75 140.6 Q47.35 140.1 46.35 140.1 L45.8 139.75 Q45.45 139.35 45.65 139.35 47.3 139.3 49.1 140.1 48.6 138.3 47.4 137.25 46.2 136.2 43.7 135.3 L40.2 133.9 Q39.0 133.2 37.65 131.7 37.5 131.55 37.8 131.25 38.15 130.9 38.25 131.05 L41.1 133.45"
        />
        <path
          fill="#0d131a"
          d="M41.55 137.4 Q41.0 136.95 41.25 136.9 41.45 136.8 42.1 137.25 43.05 137.9 44.55 138.6 47.25 139.85 47.8 143.55 48.05 145.15 47.75 145.3 47.4 145.5 45.85 144.55 44.2 143.6 41.9 142.95 L41.6 142.55 Q41.45 142.2 41.65 142.25 44.65 142.9 47.05 144.35 46.7 140.3 44.35 139.1 L41.55 137.4"
        />
        <path
          fill="#0d131a"
          d="M41.75 146.15 L41.45 142.9 Q41.1 141.85 39.8 141.2 L37.2 139.55 36.75 138.85 Q37.0 138.8 37.8 139.35 L40.45 140.85 Q41.6 141.45 42.0 142.3 42.3 142.95 42.4 144.4 42.6 146.85 42.25 147.0 41.9 147.2 39.8 145.8 37.85 144.5 35.65 143.65 L29.7 141.8 Q22.7 139.8 20.45 136.15 18.1 132.45 22.1 129.1 L22.6 129.2 22.8 129.55 Q19.3 132.4 21.9 136.05 24.25 139.4 29.65 140.95 34.6 142.35 36.5 143.15 38.8 144.1 41.75 146.15"
        />
        <path
          fill="#914897"
          d="M39.15 98.35 Q44.3 105.65 45.5 109.4 47.1 114.2 44.85 119.05 L41.5 126.65 Q40.25 129.35 38.85 130.6 L36.3 132.5 Q34.85 133.2 32.85 133.05 L29.15 132.5 25.6 131.5 Q26.7 131.7 26.5 131.3 L25.05 130.2 Q18.1 126.35 17.7 116.05 17.3 105.65 24.1 98.8 27.5 95.4 30.1 94.5 35.2 92.7 39.15 98.35"
        />
        <path
          fill="#7f3c83"
          d="M42.5 103.35 Q45.45 108.0 46.0 111.35 46.7 115.15 44.85 119.05 L41.5 126.65 Q40.25 129.35 38.85 130.6 L36.3 132.3 32.85 133.05 Q29.95 133.3 28.1 133.05 26.25 132.8 27.2 132.35 34.35 130.05 39.6 121.3 45.4 111.75 42.5 103.35"
        />
        <path
          fill="#0d131a"
          d="M24.35 97.9 Q27.45 95.55 27.85 95.3 30.9 93.45 33.35 93.75 36.9 94.2 39.55 98.05 44.95 105.7 46.2 109.4 47.9 114.35 45.6 119.25 L42.95 124.5 41.2 128.4 Q40.3 129.95 39.15 130.95 36.85 132.95 33.45 133.25 L32.15 133.1 Q31.7 132.85 32.75 132.55 L35.55 131.8 Q37.4 131.15 38.55 130.2 39.55 129.3 40.35 127.85 L42.05 124.15 44.4 118.85 Q46.6 114.2 45.05 109.55 43.85 105.9 38.75 98.6 36.6 95.55 33.35 95.2 31.2 94.95 28.25 96.6 26.75 97.45 25.0 98.65 L23.85 98.8 Q23.5 98.6 24.35 97.9"
        />
        <path
          fill="#fffbda"
          d="M28.1 63.1 Q22.2 62.75 17.75 63.05 23.55 59.9 32.8 59.8 40.75 59.7 47.35 61.95 49.75 62.75 48.95 65.3 48.1 67.9 47.05 67.35 39.9 63.85 28.1 63.1"
        />
        <path
          fill="#0d131a"
          d="M31.15 62.9 Q39.45 63.7 45.35 66.15 47.15 66.9 47.05 67.3 47.0 67.7 44.95 66.9 39.0 64.6 31.1 63.8 L20.0 63.5 16.95 63.25 Q16.8 62.9 19.55 61.8 30.3 57.25 45.55 60.95 47.5 61.45 47.35 61.8 L45.25 61.75 Q38.65 60.2 32.5 60.2 24.95 60.25 19.45 62.7 25.0 62.3 31.15 62.9"
        />
        <path
          fill="#0d131a"
          d="M93.9 17.55 Q94.0 18.0 93.35 17.75 L91.0 17.55 Q86.7 19.1 84.9 31.15 L84.45 31.2 Q84.0 31.0 84.05 30.8 84.95 24.65 86.65 21.0 88.35 17.4 90.6 16.6 L93.2 16.85 Q93.85 17.1 93.9 17.55"
        />
        <path
          fill="#0d131a"
          d="M42.2 47.1 Q42.4 47.05 42.3 47.65 L42.0 48.3 Q36.6 50.0 33.15 49.65 27.3 49.2 26.6 43.7 26.15 40.1 28.0 33.8 29.65 28.05 31.6 25.15 L32.7 25.5 Q30.7 28.65 29.25 33.25 27.75 37.85 27.55 41.85 27.35 45.0 29.0 46.85 30.45 48.45 33.0 48.75 L37.7 48.4 42.2 47.1"
        />
        <path
          fill="#0d131a"
          d="M92.9 17.1 Q94.95 19.85 96.5 23.3 98.1 26.85 98.55 29.95 99.2 34.35 97.35 37.7 95.45 41.15 92.05 41.15 L91.65 40.75 Q91.45 40.3 91.65 40.3 95.0 40.3 96.75 37.0 98.3 33.95 97.75 30.1 97.25 26.9 95.55 23.1 93.85 19.4 91.85 17.05 L92.9 17.1"
        />
      </g>
    </svg>
  );
};

export default Rattata;
